import { Globe } from 'lucide-react';
import { useI18n, LANGS } from '../i18n/I18nContext';

export const LanguageSwitcher = () => {
  const { lang, setLang } = useI18n();
  return (
    <div className="flex items-center gap-1 bg-nuit-800 border border-nuit-700 rounded-full px-1.5 py-1"
      data-testid="language-switcher">
      <Globe className="w-4 h-4 text-brume ml-1" strokeWidth={2.5} />
      {LANGS.map((l) => (
        <button key={l.id} type="button" onClick={() => setLang(l.id)} data-testid={`lang-${l.id}`}
          className={`px-2.5 py-1 rounded-full text-xs font-bold transition-colors
            ${lang === l.id ? 'bg-or-400 text-nuit-950' : 'text-brume hover:text-or-300'}`}>
          {l.label}
        </button>
      ))}
    </div>
  );
};
